
// src/web/components/group-form-panel.jsx

import React from 'react'
import connect from '../../connects/group-form-panel'
import {
  Card,
  CardText,
  CardTitle,
  CardActions
} from 'react-toolbox/lib/card'
import {
  Button
} from 'react-toolbox/lib/button'
import Dropdown from 'react-toolbox/lib/dropdown'
import FontIcon from 'react-toolbox/lib/font_icon'
import theme from './themes/flat-card.css'
import {
  Input,
} from 'react-toolbox/lib/input'
import Checkbox from 'react-toolbox/lib/checkbox'
// import Slider from 'react-toolbox/lib/slider' Slide in React Toolbx is buggy...
import Slider from 'react-rangeslider'
import 'react-rangeslider/lib/index.css'
import ProgressBar from 'react-toolbox/lib/progress_bar'
import FileUploadButton from './file-upload-button.jsx'
import RichTextEditor from './rich-text-editor.jsx'
import {
   linkUI 
} from '../../helpers/form-validator'
import AvatarEditor from 'react-avatar-editor'
import _ from 'lodash'

function calcCrop(avatar) {
  if (!avatar)
    return undefined

  const rect = avatar.getCroppingRect()
  const width = avatar.state.image.resource.width
  const height = avatar.state.image.resource.height
  //console.log(`rect x:${rect.x} y:${rect.y} w:${rect.width} h:${rect.height}, image: w:${width} h:${height}`)
  //console.log(`calc x:${width * rect.x} y:${height * rect.y} w:${width * rect.width} h:${height * rect.height}`)

  return {
    x: width * rect.x,
    y: height * rect.y,
    width: width * rect.width,
    height: height * rect.height,
  }
}

function dropdownTemplate(item) {
  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <FontIcon value={item.icon} style={{ verticalAlign:'middle' }}/>
      <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 5 }}>
        <strong>{item.label}</strong>
        <small>{item.description}</small>
      </div>
    </div>
  )
}

class GroupFormPanel extends React.Component {
  state = { scale: 1.5 }

  onChange = ()=> this.props.updateUI({ cancelRemindMail: !this.props.ui.cancelRemindMail })
  onChangeLocale = (locale)=> this.props.updateUI({ locale })

  render() {
    const {
      t,
      ui,
      isUpdating,
      group,
      updateUI,
      uploadFile,
      uploadedFile,
      validateAndSubmit,
      isUploading,
    } = this.props

    return (
      <Card theme={theme}>
        <form onSubmit={(e) => validateAndSubmit(this.props, calcCrop(this.refs.avatar), e)}>
          <CardText>
            <normal><strong>{t('label:グループ名')}</strong></normal>
            <Input name="groupName" required
              label={t('label:グループ名')}
              value={ui.name}
              icon='person'
              error={ui.nameError && t('error:グループ名を入力してください')}
              onChange={linkUI(this, 'name')} />
          </CardText>

          <CardText>
            <normal><strong>{t('label:グループの公開範囲')}</strong></normal>
            <Dropdown auto
                source={[
                  { value: 'public_access', icon: 'lock_open', label: t('label:公開グループ'), description: t('label:公開グループの説明') },
                  { value: 'private_access', icon: 'lock_outline', label: t('label:非公開グループ'), description: t('label:非公開グループの説明') },
                ]}
                template={dropdownTemplate}
                value={ui.access_type}
                onChange={(access_type)=> updateUI({ access_type })} />
          </CardText>

          <CardText>
            <normal><strong>{t('label:言語')}</strong></normal>
            <Dropdown auto
                source={[{ value: 'ja' }, { value: 'en' }]}
                template={(item)=> <span>{t('language:' + item.value)}</span>}
                value={ui.locale}
                onChange={this.onChangeLocale} />
          </CardText>

          {!group && 
          <CardText>
            <Checkbox className={theme.checkbox}
              checked={ui.cancelRemindMail}
              label={t('label:すべてのリマインド通知を送らない')}
              onChange={this.onChange} />
          </CardText>
          }

          {group &&
          <CardText>
            <normal><strong>{t('label:アイコン画像')}</strong></normal><br />
            {!uploadedFile && !isUploading &&
              <div>
                <img style={{ width: 100, height: 100, borderRadius: '50%' }} src={group.icon_image.thumb_url} />
              </div>
            }
            {uploadedFile && !isUploading && uploadedFile.file &&
              <div style={{ display: 'flex', flexDirection: 'column', width: 210 }}>
                <AvatarEditor ref="avatar"
                    image={uploadedFile.file.thumb_url}
                    width={200}
                    height={200}
                    border={5}
                    scale={this.state.scale}
                    style={{ cursor: 'move' }} />
                <Slider
                    min={1}
                    max={5}
                    step={0.05}
                    tooltip={false}
                    value={this.state.scale}
                    onChange={(value)=> this.setState({ scale: value })} />
              </div>
            }
            {isUploading &&
              <div style={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'flex-start', marginLeft: '10px' }}>
                <ProgressBar type='circular' multicolor mode='indeterminate' />
              </div>
            }
            <FileUploadButton raised
              icon='add_a_photo'
              label='ファイルを選択'
              single
              onChange={(file)=> uploadFile(this.props, file)} />
          </CardText>
          }

          <CardText>
            <normal><strong>{t('label:グループのミッション')}</strong></normal><br />
            <RichTextEditor
                placeholder={t('label:ミッションを入力してください')}
                onEditorInitialized={(handlers) => {
                  updateUI({ handlers })
                  group && group.description && setTimeout(()=> handlers.insertValue(group.description), 0)
                }} />
          </CardText>
          <CardActions>
            <Button raised primary
              type="submit"
              disabled={isUpdating}
              style={{ width: '100%' }}
              label={t(group ? 'label:更新' : 'label:新規作成')} />
          </CardActions>
        </form>
      </Card>
    )
  }
}

export const RawGroupFormPanel = GroupFormPanel
export default connect(GroupFormPanel)



// WEBPACK FOOTER //
// ./src/web/components/group-form-panel.jsx